// @flow strict
import React from 'react';
import Layout from '../components/Layout';
import Constellation from '../components/Constellation';
import { useSiteMetadata } from '../hooks';

// Newsreader is self-hosted rather than pulled from Google Fonts: no
// third-party request, and no render-blocking round trip before the headline
// can paint. The woff2 files are only fetched by pages that use the family.

const HEADING = "Hi, I'm Mrunal.";
const INTRO = 'Welcome to my blog! This is a constellation of my passions. I build tech & AI '
  + 'products, learn about businesses, collect ideas and document experiences, places, and '
  + 'moments that shape me!';

const ConstellationTemplate = () => {
  const { title: siteTitle } = useSiteMetadata();

  return (
    <Layout title={`Constellation - ${siteTitle}`} description={INTRO} fullWidth>
      <Constellation heading={HEADING} intro={INTRO} />
    </Layout>
  );
};

export default ConstellationTemplate;
